<div class="top-margin" role="alert" aria-live="assertive">
    <div class="container">
      <div class="d-flex align-items-center justify-content-center">
        <div class="col-md-6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4" tabindex="0">{{language.error}}!!</h1>
            <h4 class="pt-3"  tabindex="0"> {{language.somethingWentWrong}}</h4>
            <p class="text-muted"  tabindex="0"> {{language.pleaseConatctAdministrator}}..</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  